export const dsr_report_endpoint = {
  key: "data",
  get: "/dsr_report/get",
};
export const documents = {
  key: "documents",
  get: "/documents/get",
  delete: "/document_delete",
};
export const documentsDetails = {
  key: "domain",
  documentKey: "documents",
  get: "/domain/get",
  document: "/documents/get",
  feedback: "/feedback/save",
  post: "/domain/save",
  delete: "",
  update: "/document_update",
};
export const erpLog = {
  key: "domain",
  documentKey: "documents",
  get: "/erp_logs/get",
};
export const auditLog = {
  key: "audit_logs",
  get: "/audit_logs/get",
};
export const user_activity = {
  key: "user_activity_logs",
  get: "/user_activity_logs/get",
  delete: "/user_activity_logs/get",
  post: "/user_activity_logs/get",
};
export const email_read_logs = {
  key: "email_read_logs",
  get: "/email_read_logs/get",
  delete: "",
  post: "",
};
export const email_inbox = {
  key: "email_archives",
  get: "/email_archive/get",
  delete: "",
  post: "",
};
export const email_file = {
  get: "/email_file/get",
};

export const documentsUpload = {
  post: "/upload",
};
export const erpCustomerMapping = {
  key: "customer_mapping",
  get: "/snc_customer_mapping/get",
};

export const users = {
  key: "users",
  get: "/user/get",
  post: "/user/save",
  update: "",
  delete: "/user/delete",
};

export const companies = {
  key: "company",
  get: "/company/get",
  post: "/company/save",
  company: "/snc_company/get",
  delete: "/company/delete",
};
export const roles = {
  key: "role",
  get: "/role/get",
  post: "/role/save",
  delete: "/role/delete",
};
export const jobId = {
  get: "/job/",
};
export const runDocument = {
  post: "/run/document",
};
export const runErpReprocess = {
  post: "/reprocess_erp",
};
export const PRESIGNED_URL = {
  get: "/presignedurl/get/",
};

export const retailers = {
  key: "retailers",
  get: "/retailer/get",
  post: "/retailer/save",
  update: "",
  delete: "/retailer/delete",
  import: "/retailer_import",
  export: "/retailer_export",
};
export const validation = {
  key: "validations",
  get: "/validation/get",
  post: "/validation/save",
  update: "",
  delete: "/validation/delete",
};
export const terminalKey = {
  key: "terminal_keys",
  get: "/terminal_key/get",
  post: "/terminal_key/save",
  update: "",
  delete: "/terminal_key/delete",
};

export const synonym = {
  key: "synonym_obj",
  get: "/synonyms/get",
  post: "/synonym/save",
  update: "/synonym/update",
  import: "/synonym_import",
  export: "/synonym_export",
  delete: "",
};
export const erp = {
  key: "erp_schema",
  get: "/snc_erp_schema/get",
  post: "",
  update: "",
  delete: "",
};
export const erpSku = {
  key: "erp_sku",
  get: "/snc_erp_sku/get",
  post: "",
  update: "",
  delete: "",
};

export const uom_mapping = {
  key: "uom_mapping",
  get: "/uom/mapping/get",
  post: "/uom/mapping/save",
  update: "",
  delete: "/uom/mapping/delete",
  import: "/uom/mapping/save",
  export: "/uom_mapping_export",
};
export const customer_mapping = {
  key: "uom_mapping",
  get: "/uom/customer_mapping/get",
  post: "/uom/customer_mapping/save",
  update: "",
  delete: "/uom/customer_mapping/delete",
  import: "/uom/customer_mapping/save",
  export: "/customer_mapping",
};
export const workflow = {
  key: "workflows",
  get: "/workflow/get",
  post: "/workflow/save",
  update: "",
  delete: "",
};
export const snc_erp_uom = {
  key: "erp_uom_list",
  get: "/snc_erp_uom/get",
  post: "",
  update: "",
  delete: "",
};

export const sku_mapping = {
  key: "sku_mapping",
  get: "/sku/mapping/get",
  post: "/sku/mapping/save",
  update: "/sku/mapping/update",
  delete: "/sku/mapping/delete",
  import: "/sku_mapping_import",
  export: "/sku_mapping_export",
};
export const uom_conversion = {
  key: "uom_conversion_list",
  get: "/uom/conversion/get",
  post: "/uom/conversion/save",
  update: "",
  delete: "/uom/conversion/delete",
};
export const classification = {
  key: "classifications",
  get: "/classification/get",
  post: "/classification/save",
  structured_elements_save: "/structured_elements/save",
  update: "/classification/update",
  delete: "",
};
export const dashboard = {
  key: "dashboard_details",
  get: "/dashboard/get",
  // get: "/dashboard/details",
  post: "",
  update: "",
  delete: "",
};

export const email_listener = {
  key: "email_listeners",
  get: "/email_listener/get",
  post: "/email_listener/save",
  update: "",
  delete: "/email_listener/delete",
};
export const retailer_group = {
  key: "retailer_groups",
  get: "/retailer_group/get",
  post: "/retailer_group/save",
  update: "",
  delete: "",
};
export const snc_customers = {
  key: "customers",
  get: "/snc_customers/get",
  post: "/retailer_group/save",
  update: "",
  delete: "",
};
